"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocaleOptionsWithNames = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const useLocaleOptionsWithNames = (localeOptions = []) => {
    const getMessage = (0, epic_games_nav_shared_1.useLocalization)();
    const namedLocaleOptions = [];
    localeOptions.forEach((localeOption) => {
        let name = localeOption.name;
        if (localeOption.name.indexOf("epic.") > -1) {
            name = getMessage(localeOption.name) || localeOption.name || "";
        }
        namedLocaleOptions.push(Object.assign(Object.assign({}, localeOption), { name, lang: localeOption.lang }));
    });
    return namedLocaleOptions;
};
exports.useLocaleOptionsWithNames = useLocaleOptionsWithNames;
//# sourceMappingURL=locale.hooks.js.map